import React from 'react';
import { Empty } from 'antd';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Line } from 'react-chartjs-2';

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const LineGraph = ({ dashboardData, title = "University Trends" }) => {
  console.log('Raw dashboardData:', dashboardData);
  
  // Get the raw university data - this should be an array of objects with university and candidate_count
  const rawUniversityData = dashboardData?.field_data?.['University attended'] || [];
  console.log('Raw university data:', rawUniversityData);

  // Transform data using the same logic as DynamicVisualization
  const lineData = rawUniversityData.map((item, index) => {
    console.log('Processing university item:', item); // Debug each university object
    
    // Handle different data structures like DynamicVisualization does
    let label, count;
    
    if (item.university) {
      // University attended data structure
      label = item.university;
      count = item.candidate_count;
    } else if (item.language) {
      // Languages spoken data structure
      label = item.language;
      count = item.candidate_count;
    } else if (item.value !== undefined) {
      // Generic value structure
      label = item.value;
      count = item.count || 1;
    } else if (typeof item === 'string') {
      // Simple string values
      label = item;
      count = 1;
    } else {
      // Fallback to field label or index
      label = item['University attended'] || `Item ${index + 1}`;
      count = item.candidate_count || item.count || 1;
    }
    
    return {
      key: String(index + 1),
      label: String(label),
      count: Number(count) || 1
    };
  }).filter(item => item.label && item.count !== null && item.count !== undefined);

  console.log('Final line data:', lineData);

  // Test data transformation
  if (rawUniversityData.length > 0) {
    console.log('=== DATA TRANSFORMATION TEST ===');
    console.log('First item from API:', rawUniversityData[0]);
    console.log('First item after transformation:', lineData[0]);
    console.log('Expected structure: {key: "1", label: "Bocconi", count: 7}');
    console.log('Actual structure:', lineData[0]);
    console.log('=== END TEST ===');
  }

  // If no university data is available
  if (lineData.length === 0) {
    return (
      <div className="bg-card rounded-lg shadow-md p-6">
        <h3 className="text-xl font-semibold text-foreground mb-4">{title}</h3>
        <Empty description="No university data available" />
      </div>
    );
  }

  // Transform data for Chart.js
  const chartData = {
    labels: lineData.map(item => item.label),
    datasets: [
      {
        label: 'Number of Candidates',
        data: lineData.map(item => item.count),
        borderColor: '#1890ff',
        backgroundColor: 'rgba(24, 144, 255, 0.1)',
        borderWidth: 3,
        pointBackgroundColor: '#ffffff',
        pointBorderColor: '#1890ff',
        pointBorderWidth: 2,
        pointRadius: 6,
        pointHoverRadius: 8,
        tension: 0.4,
        fill: false,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            return `Candidates: ${context.parsed.y}`;
          }
        }
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'University Name',
          font: {
            size: 14,
            weight: 'bold'
          }
        },
        ticks: {
          maxRotation: 45,
          minRotation: 0
        }
      },
      y: {
        title: {
          display: true,
          text: 'Number of Candidates',
          font: {
            size: 14,
            weight: 'bold'
          }
        },
        beginAtZero: true
      }
    }
  };

  return (
    <div className="bg-card rounded-lg shadow-md p-6">
      <h3 className="text-xl font-semibold text-foreground mb-4">{title}</h3>
      <div style={{ height: '400px' }}>
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
};

export default LineGraph; 